module.exports = __webpack_public_path__ + "img/partners-colored.a41949d7.png";